<template>
  <div>
    <AccountSearchbar @updateSearch="search = $event" class="mb-8" />
    <AccountInfoCard
      v-for="account in filteredAccounts"
      :key="account._id"
      :id="account._id"
      :name="account.name"
      :companyName="account.companyName"
      :cnpj="account.companyCnpj"
      :email="account.email"
      :phone="account.phone"
      :address="account.street"
      :number="account.number"
      :zip="account.zip"
      :neighborhood="account.neighborhood"
      :state="account.state"
      :blocked="account.blocked"
      :aggregateNumber="account.aggregateNumber"
    />
  </div>
</template>

<script>
import AccountSearchbar from "@/components/atoms/Contas/accounts-searchbar";
import AccountInfoCard from "@/components/molecules/Contas/account-info-card";

export default {
  components: {
    AccountSearchbar,
    AccountInfoCard
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    accounts() {
      return this.$store.getters.accounts.filter(
        account => account.email != this.$store.state.user.email
      );
    },
    accountsWithAggregateNumber() {
      return this.accounts.map(
        account => {
          if (Number(account.role) !== 1) account.aggregateNumber = null;
          else
            account.aggregateNumber = this.accounts.filter(
              filteredAccount => filteredAccount.companyCnpj === account.companyCnpj &&
                Number(filteredAccount.role) === 0
            ).length;
          return account;
        }
      );
    },
    filteredAccounts() {
      return this.accountsWithAggregateNumber.filter(account => account.email.match(this.search));
    }
  }
};
</script>

<style scoped>
</style>